import {toArray} from "./toArray";

export function groupShipmentsByInventory(shipments) {
    const groupedShipments = {};

    toArray(shipments).forEach(shipment => {
        const inventoryId = shipment.inventory?.['@id'] ?? null;
        const inventoryName = shipment.inventory?.inventoryCenterName;

        if (!groupedShipments[inventoryId]) {
            groupedShipments[inventoryId] = {
                inventoryId,
                inventoryName,
                shipments: []
            };
        }

        groupedShipments[inventoryId].shipments.push(shipment);
    });

    return groupedShipments;
}
